<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100"
				style="display: flex; justify-content:space-between; align-items: center;">
				<h3 class="order-title">Loan Information</h3>
				<div>
					<a :href="'#/print_loan_contract/' + loan.hash_id" target="_blank">
						<md-button class="md-just-icon md-simple md-primary">
							<md-icon>article</md-icon>
							<md-tooltip>Loan Contract</md-tooltip>
						</md-button>
					</a>
					<a :href="'#/print_loan/' + loan.hash_id" target="_blank">
						<md-button class="md-just-icon md-simple md-primary">
							<md-icon>print</md-icon>
							<md-tooltip>Loan Payment</md-tooltip>
						</md-button>
					</a>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<table>
					<tr>
						<td style="width: 150px">Loan amount</td>
						<td style="width: 40px">:</td>
						<td>{{config.moneylify(loan.total_principal)}}</td>
					</tr>
					<tr>
						<td>Loan term</td>
						<td>:</td>
						<td>{{loan.term}} Months</td>
					</tr>
					<tr>
						<td>Interest rate</td>
						<td>:</td>
						<td>{{loan.interest_rate}}%</td>
					</tr>
					<tr>
						<td>Total interest</td>
						<td>:</td>
						<td>{{config.moneylify(loan.total_interest)}}</td>
					</tr>
					<tr>
						<td>Loan fee</td>
						<td>:</td>
						<td>{{config.moneylify(loan.loan_fee)}}</td>
					</tr>
					<tr>
						<td>Total payment</td>
						<td>:</td>
						<td><b>{{config.moneylify(loan.total_interest + loan.total_principal)}}</b></td>
					</tr>
					<tr>
						<td>Status</td>
						<td>:</td>
						<td>
							<span class="active" v-if="loan.status == 'act'">{{config.getStatus(loan.status)}}</span>
							<span class="late" v-if="loan.status == 'fin'">{{config.getStatus(loan.status)}}</span>
						</td>
					</tr>

				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<table style="border-width: 0px;">
					<tr>
						<td>Client</td>
						<td>:</td>
						<td>{{loan.name}}</td>
					</tr>
					<tr>
						<td style="width: 150px">Initial payment</td>
						<td style="width:40px">:</td>
						<td>{{config.moneylify(loan.initial_payment)}}</td>
					</tr>
					<tr>
						<td>Monthly payment</td>
						<td>:</td>
						<td>{{config.moneylify(loan.monthly_payment)}}</td>
					</tr>
					<tr>
						<td>Final payment</td>
						<td>:</td>
						<td>{{config.moneylify(loan.final_payment)}}</td>
					</tr>
					<tr>
						<td>Paid EMIs</td>
						<td>:</td>
						<td>{{loan.total_paid}} / {{loan.term}}</td>
					</tr>
					<!-- <tr>
					<td>Remaining balance</td>
					<td>:</td>
					<td>{{config.moneylify(loan.loan_balance)}}</td>
				</tr> -->
					<tr>
						<td>Loan period</td>
						<td>:</td>
						<td>{{config.datelify(loan.start_date)}} - {{config.datelify(loan.end_date)}}</td>
					</tr>
					<tr>
						<td>Next payment</td>
						<td>:</td>
						<td>
							<span v-if="loan.total_paid == loan.term">N/A</span>
							<span class="active"
								v-else-if="String(loan.next_payment).length >0">{{config.datelify(loan.next_payment)}}</span>
						</td>
						<!-- <td><span class="late" v-if="false">12/11/2021</span></td> -->
					</tr>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">Loan Remark</h3>
				<p v-if="String(loan.note).length > 0">{{loan.note}}</p>
				<p v-else>Not available</p>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">Guarantors</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-table v-if="guarantorList.length > 0">
					<md-table-row>
						<md-table-head>Client ID</md-table-head>
						<md-table-head>Name</md-table-head>
						<md-table-head>Phone</md-table-head>
						<md-table-head>Action</md-table-head>
					</md-table-row>

					<md-table-row v-for="(guarantor, index) in guarantorList">
						<md-table-cell><b>CID: {{guarantor.hash_id}}</b><br>{{ config.datelify(guarantor.created_date) }}</md-table-cell>
						<md-table-cell><b>{{ guarantor.name }}</b><br>{{ guarantor.name_khmer }}</md-table-cell>
						<md-table-cell>{{guarantor.phone}}</md-table-cell>
						<md-table-cell>
							<router-link :to="'/clients/detail/' + guarantor.hash_id">
								<md-button class="md-just-icon md-simple md-success">
									<md-icon>visibility</md-icon>
									<md-tooltip md-direction="top">View client information</md-tooltip>
								</md-button>
							</router-link>
						</md-table-cell>
					</md-table-row>
				</md-table>
				<p v-else>Not available</p>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">Payment History</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-table v-if="paymentList.length > 0">
					<md-table-row>
						<md-table-head>Term</md-table-head>
						<md-table-head>Payment ID</md-table-head>
						<md-table-head>Payment Date</md-table-head>
						<md-table-head>Total</md-table-head>
						<md-table-head>Principal</md-table-head>
						<md-table-head>Interest</md-table-head>
						<md-table-head>Total</md-table-head>
						<md-table-head>Principal Balance</md-table-head>
						<md-table-head>Balance</md-table-head>
						<md-table-head>Status</md-table-head>
						<md-table-head>Action</md-table-head>
					</md-table-row>

					<md-table-row v-for="(payment, index) in paymentList">
						<md-table-cell>{{ payment.term_id }}</md-table-cell>
						<md-table-cell>{{ payment.hash_id }}</md-table-cell>
						<md-table-cell>{{ config.datelify(payment.due_date) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.currentTotal) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.principal) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.interest) }}</md-table-cell>
						<md-table-cell><b>{{ config.moneylify(payment.interest + payment.principal)}}</b></md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.balance) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.interestBalance) }}</md-table-cell>
						<md-table-cell>
							<span class="late" v-if="payment.status == 'pnd'">{{ config.getStatus(payment.status) }}</span>
							<span class="active" v-if="payment.status == 'pad'">{{ config.getStatus(payment.status) }}</span>
						</md-table-cell>
						<md-table-cell>
							<md-button class="md-just-icon md-simple md-primary"
								v-if="payment.due_date > ((new Date()).getTime() / 1000) && payment.status=='pnd'"
								@click="payPayment(payment.id)">
								<md-icon>price_check</md-icon>
								<md-tooltip md-direction="top">Pay</md-tooltip>
							</md-button>
							<md-button class="md-just-icon md-simple md-danger"
								v-if="payment.due_date < ((new Date()).getTime() / 1000) && payment.status =='pnd'"
								@click="openLateDialog(payment.id)">
								<md-icon>price_check</md-icon>
								<md-tooltip md-direction="top">Pay as late</md-tooltip>
							</md-button>
							<span v-if="payment.status=='pad'">{{config.datelify(payment.paid_date)}}</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-size-100 text-right"
				v-if="loan.status != 'fin' && loan.total_paid < loan.term - 1">
				<md-button class="md-raised md-primary" @click="payAllDialog = true">
					Pay All</md-button>
			</div>
		</div>
		<md-dialog-confirm :md-active.sync="payDialog" md-title="Are you sure want to mark this as paid ?" md-content=""
			md-confirm-text="OK" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="payPayment" />
		<md-dialog-confirm :md-active.sync="payAllDialog"
			:md-title="'Are you sure want to finish this loan ? Total payment is ' + config.moneylify(payAllTotal)"
			md-content="" md-confirm-text="OK" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="payAllPayment" />

		<md-dialog-prompt :md-active="lateDialog" md-title="Late Payment Fee" md-confirm-text="Confirm"
			md-cancel-text="Cancel" md-input-maxlength="8" md-input-placeholder="Fee ($)" @md-cancel="onCancel"
			@md-confirm="payLatePayment()" v-model="lateFee" ref="dialog">
		</md-dialog-prompt>
	</div>
</template>
<script>
	export default {
		created() {
			this.getLoan();
			this.getPayment();
			this.getGuarantor();
			this.getPayAllTotal();
		},
		data() {
			return {
				loaded: false,
				paymentList: [],
				guarantorList: [],
				payDialog: false,
				lateDialog: false,
				payAllDialog: false,
				payID: "",
				payLateID: "",
				lateFee: "",
				payAllTotal: 0,
				loan: {
					id: "",
					hash_id: "",
					interest_amount: "",
					loan_fee: "",
					total_payment: "",
					amount: "",
					term: "",
					initial_payment: "",
					monthly_payment: "",
					start_date: "",
					end_date: "",
					name: "",
					phone: "",
					next_payment: "",
					loan_balance: "",
					total_paid: "",
					note: "",
					status: ""
				},
			}
		},
		methods: {
			getLoan(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get/" + this.$route.params.hash_id).then(data => {
					this.loan = data.body.data
					this.loaded = true
				})
			},
			getPayment() {
				this.$http.get(this.config.api + "/admin/loan/get_payment/" + this.$route.params.hash_id).then(data => {
					this.paymentList = data.body.data
				})
			},
			getGuarantor() {
				this.$http.get(this.config.api + "/admin/loan/get_guarantor/" + this.$route.params.hash_id).then(data => {
					this.guarantorList = data.body.data
				})
			},
			getPayAllTotal() {
				this.$http.get(this.config.api + "/admin/loan/get/pay_all/" + this.$route.params.hash_id).then(data => {
					// this.payAllTotal = data.body.data.balance + data.body.data.interest + data.body.data.fine
					this.payAllTotal = data.body.data.balance + data.body.data.fine
				})
			},
			payPayment(id = "") {
				if (id == "" && String(this.payID).length > 0) {
					this.$http.post(this.config.api + "/admin/loan/pay/payment", {
						payment_id: this.payID,
						late_fee: "0",
						loan_id: this.loan.id
					}).then(data => {
						if (data.body.status == 'success') {
							this.getPayment();
							this.getLoan();
						}
					})
				} else {
					this.payID = id;
					this.payDialog = true;
				}

			},
			openLateDialog(id) {
				this.lateDialog = true;
				this.payLateID = id;
			},
			payLatePayment() {

				let id = this.payLateID;
				let fee = this.lateFee;
				this.onCancel();
				if (String(id).length > 0 && String(fee).length > 0) {
					this.$http.post(this.config.api + "/admin/loan/pay/payment", {
						payment_id: id,
						late_fee: fee,
						loan_id: this.loan.id
					}).then(data => {
						if (data.body.status == 'success') {
							this.getPayment();
							this.getLoan();
						}
					})
				}

			},
			payAllPayment() {
				this.$http.post(this.config.api + "/admin/loan/pay_all/payment", {
					loan_id: this.loan.id
				}).then(data => {
					if (data.body.status == 'success') {
						this.getPayment();
						this.getLoan();
					}
				})
			},
			onCancel() {
				this.payDialog = false;
				this.lateDialog = false;
				this.payID = "";
				this.lateFee = "";
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Loans/Detail.vue